import { MethodType } from '../constants/MethodType'

const api = require('./api')

// ----- CRITERIA ----- //
export const fetchCriteria = params => api.request(1, '/criterias', MethodType.GET, params)

export const delCriteria = (id, params) => api.request(1, `/criterias/${id}`, MethodType.DELETE, params)

export const addCriteria = params => api.request(1, '/criterias', MethodType.POST, params)

export const modCriteria = (id, params) => api.request(1, `/criterias/${id}`, MethodType.PUT, params)

export const fetchBackendValue = params => api.request(1, '/getCriteriaColumnValues', MethodType.GET, params)

// criteria options (SITE)
export const fetchSite = params => api.request(1, '/sites', MethodType.GET, params)

export const fetchSiteGeo = params => api.request(1, '/siteGeos?maxResults=1000', MethodType.GET, params)

// criteria options (TRACK)
export const fetchTrack = params => api.request(1, '/trackBrands?maxResults=100&brandId=0001&includes=creator', MethodType.GET, params)

export const fetchTrackCampaign = (id, params) => api.request(1, `/track/campaigns/${id}`, MethodType.GET, params)

export const fetchTrackMedias = params => api.request(1, '/track/medias', MethodType.GET, params)

export const fetchTrackPlacements = (id, params) => api.request(1, `/track/placements/${id}`, MethodType.GET, params)

export const fetchTrackKeywords = (id, params) => api.request(1, `/track/keywords/${id}`, MethodType.GET, params)

export const fetchTrackGeo = (id, params) => api.request(1, `/track/geos/${id}`, MethodType.GET, params)

export const fetchTrackGeoById = (id, params) => api.request(1, `/track/geosByIds/${id}`, MethodType.GET, params)

// criteria options (LINE)
export const fetchLineTag = params => api.request(1, '/lineTags?maxResults=1000', MethodType.GET, params)

// ----- SEGMENT ----- //
export const fetchSegment = params => api.request(1, '/segments', MethodType.GET, params)

export const delSegment = (id, params) => api.request(1, `/segments/${id}`, MethodType.DELETE, params)

export const addSegment = (params) => api.request(1, '/segments', MethodType.POST, params)

export const modSegment = (id, params) => api.request(1, `/segments/${id}`, MethodType.PUT, params)

export const reloadSegment = (id, params) => api.request(1, `/sendSegmentPreview/${id}`, MethodType.POST, params)

export const fetchSegmentPreview = (id, params) => api.request(1, `/getLatestSegmentPreview/${id}`, MethodType.GET, params)

// segment options (CHT)
export const fetchInterest = params => api.request(1, '/chtInterests', MethodType.GET, params)

export const fetchProfile = params => api.request(1, '/chtDims/profile', MethodType.GET, params)

export const fetchApp = params => api.request(1, '/chtAppCategorys', MethodType.GET, params)

export const fetchInvoiceTaxonomy = params => api.request(1, '/invoiceTaxonomyLabels', MethodType.GET, params)

export const fetchPredictionTag = params => api.request(1, '/predictionTags', MethodType.GET, params)
